module.exports = __webpack_public_path__ + "static/media/bgEmpresas.b90862ce.jpeg";